import React from 'react';

export default function AlertIcon(props) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 0C7.16334 0 0 7.16334 0 16C0 24.8367 7.16334 32 16 32C24.8367 32 32 24.8367 32 16C32 7.16334 24.8367 0 16 0ZM16 30.3772C8.05959 30.3772 1.62277 23.9404 1.62277 16C1.62277 8.05959 8.05959 1.62277 16 1.62277C23.9404 1.62277 30.3772 8.05959 30.3772 16C30.3772 23.9404 23.9404 30.3772 16 30.3772Z"
				fill="black"
			/>
			<path
				d="M16.1318 22.472C15.3962 22.472 14.7998 23.0684 14.7998 23.804C14.7998 24.5396 15.3962 25.136 16.1318 25.136C16.8674 25.136 17.4638 24.5396 17.4638 23.804C17.4638 23.0684 16.8674 22.472 16.1318 22.472ZM17.2718 13.28V8H14.9918V13.28L15.5918 20.336H16.6718L17.2718 13.28Z"
				fill="black"
			/>
		</svg>
	);
}
